/**
 * RESPONSIBILITY: one photograph in an event's gallery.
 */
import type { ImageValue } from '@framework/core';
import { Row, Text, Img } from '@framework/core/decorators';

@Row()
export class PictureRow {
  @Img({ label: 'Picture', folder: 'events', maxSizeMb: 12, size: '1200 × 800' })
  image!: ImageValue;

  @Text({ label: 'Caption', maxLength: 300 })
  caption!: string;
}
